import { useToast } from '@nextgen-web-framework/all';
import { CartNotification } from '../components/cart-notification/CartNotification';
import { CartNotificationProps } from '../components/cart-notification/types/propsType';

type createToastProps = {
  timeOut: number;
} & CartNotificationProps;

let count = 0;
export function useCartNotification(uniqueText: string) {
  const { addToast, deleteToast } = useToast();

  function createToast(
    { content, subtext, theme, clickIcon, icon, rightSeperator, textlink, timeOut }: createToastProps,
    handleClick?: (toasId: string) => unknown,
  ) {
    const toastId = `CART_TOAST-${uniqueText}-${count}`;
    const toast = clickIcon ? (
      <CartNotification
        theme={theme}
        rightSeperator={rightSeperator}
        onClick={() => handleClick && handleClick(toastId)}
        content={content}
        subtext={subtext}
        clickIcon={clickIcon}
        icon={icon}
      />
    ) : (
      <CartNotification
        theme={theme}
        rightSeperator={rightSeperator}
        onClick={() => handleClick && handleClick(toastId)}
        content={content}
        icon={icon}
        subtext={subtext}
        textlink={textlink}
      />
    );
    deleteToast(`CART_TOAST-${uniqueText}-${count - 1}`);
    addToast({
      id: toastId,
      content: toast,
      timeout: timeOut,
    });
    count += 1;
    return toastId;
  }

  return { createToast, deleteToast };
}
